import React from 'react';

const Field = ({ label, value, onChange, textarea, placeholder, testid }) => (
  <div>
    <label className="text-xs font-semibold text-gray-500 mb-1.5 block">{label}</label>
    {textarea ? (
      <textarea value={value || ''} onChange={e => onChange(e.target.value)} placeholder={placeholder}
        className="w-full bg-white border border-gray-200 rounded-lg text-gray-900 px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-400 resize-none h-20"
        data-testid={testid} />
    ) : (
      <input value={value || ''} onChange={e => onChange(e.target.value)} placeholder={placeholder}
        className="w-full bg-white border border-gray-200 rounded-lg text-gray-900 px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-400"
        data-testid={testid} />
    )}
  </div>
);

export default Field;
